var map = {
	"./music-instructions.json": 4786,
	"./music-library-intro2024.json": 4787,
	"./music-library-launch2024.json": 4788,
	"./music-progression.json": 4789,
	"./startSourcesAdvanced.json": 4790,
	"./startSourcesSimple.json": 4791,
	"./startSourcesSimple2.json": 4792,
	"./startSourcesTracks.json": 4793
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4503;